Number.isInteger =
  Number.isInteger ||
  function (value) {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  };
// проверяем целочисленное ли значение у number (int или float)
export const cutFloatNumber = (number: number): number =>
  Number.isInteger(number)
    ? number
    : Number(parseFloat(String(number)).toFixed(2));

export const preparePriceFloatObject = (
  number: number | string | null | undefined
): {
  wholePart: string;
  floatPart: string;
} => {
  if (!number) {
    return {
      wholePart: '0',
      floatPart: ''
    };
  }
  if (Number.isInteger(+number)) {
    return {
      wholePart: String(number),
      floatPart: ''
    };
  }
  const preparedNumber = `${Number(parseFloat(String(number))).toFixed(2)}`;
  const numberArr = preparedNumber.split('.');
  return {
    wholePart: numberArr[0] || '0',
    floatPart: numberArr?.[1] || ''
  };
};
